import { HiOutlineClock } from 'react-icons/hi';
import PropTypes from 'prop-types';

import '../../styles/Card.css';

const Card = ({
  title = "Structural Design - 1",
  price = "₹XXXX",
  originalPrice,
  offerPrice,
  duration = "4 months",
  image,
  alt,
  onCardClick,
  className = "",
  showClockIcon = true,
  status
}) => {
  // Determine which price to display
  const displayPrice = offerPrice || price;
  const hasDiscount = originalPrice && originalPrice > displayPrice;

  return (
    <div
      className={`card ${onCardClick ? 'card-clickable' : ''} ${className}`}
      onClick={onCardClick}
    >
      <div className="card-content">
        {/* Image Section - Always render container, show placeholder if no image */}
        <div className={`card-image-container ${!image ? 'card-image-placeholder' : ''}`}>
          {image ? (
            <img
              src={image}
              alt={alt || title}
              className="card-image"
            />
          ) : null}
          {/* Status Badge */}
          {status && (
            <div className={`card-status-badge ${status.toLowerCase()}`}>
              {status}
            </div>
          )}
        </div>

        {/* Title */}
        <h3 className="h6 card-title">
          {title}
        </h3>

        {/* Price and Duration Row */}
        <div className="card-footer">
          {/* Price */}
          <div className="card-price-section">
            {hasDiscount && (
              <span className="body4 card-original-price">
                ₹{originalPrice}
              </span>
            )}
            <span className="body4 card-price">
              ₹{typeof displayPrice === 'string' ? displayPrice.replace(/^₹+/, '') : displayPrice}
            </span>
          </div>

          {/* Duration and Clock Icon */}
          <div className="card-duration-section">
            <span className="body3 card-duration">
              {duration}
            </span>
            {showClockIcon && (
              <div className="card-clock-icon">
                <HiOutlineClock size={16} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Card.propTypes = {
  title: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  originalPrice: PropTypes.number,
  offerPrice: PropTypes.number,
  duration: PropTypes.string,
  image: PropTypes.string,
  alt: PropTypes.string,
  onCardClick: PropTypes.func,
  className: PropTypes.string,
  showClockIcon: PropTypes.bool,
  status: PropTypes.string
};

export default Card;